import { Link } from "react-router-dom";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { SEO } from "@/components/SEO";
import { CASE_STUDIES } from "@/data/caseStudiesData";
import { buildItemListSchema } from "@/data/advancedSchemas";
import { getIcon } from "@/components/content/iconResolver";

export default function CaseStudiesIndexPage() {
  const schema = buildItemListSchema(CASE_STUDIES, "/etudes-de-cas", "Études de cas Mediastore Niort");
  const breadcrumbs = [
    { name: "Accueil", path: "/" },
    { name: "Études de cas", path: "/etudes-de-cas" },
  ];

  return (
    <div className="min-h-screen" data-testid="case-studies-index-page">
      <SEO
        title="20 Études de Cas Réelles — Mediastore Niort"
        description="20 réparations réelles documentées : iPhone tombé en piscine, MacBook café, PS5 HDMI, NAND récupération. Cas clients Mediastore Niort."
        keywords="études de cas réparation, témoignages clients Mediastore, exemples réparation Niort"
        path="/etudes-de-cas"
        schema={schema}
        breadcrumbs={breadcrumbs}
      />

      <section className="bg-gradient-to-br from-emerald-50 to-white pt-12 pb-8">
        <div className="container-custom max-w-4xl text-center">
          <Badge className="bg-emerald-100 text-emerald-700 px-3 py-1 mb-4 hover:bg-emerald-100">
            20 cas réels
          </Badge>
          <h1 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4">
            Études de cas — Réparations Mediastore Niort
          </h1>
          <p className="text-lg text-slate-700">
            20 interventions réelles documentées par notre atelier : iPhone tombés en piscine, MacBook
            avec café renversé, PS5 HDMI cassé, récupération NAND, et plus. Diagnostic gratuit au 104
            Rue de la Gare, 79000 Niort.
          </p>
        </div>
      </section>

      <section className="section-padding bg-white">
        <div className="container-custom max-w-5xl">
          <div className="grid md:grid-cols-2 gap-4">
            {CASE_STUDIES.map((c) => {
              const Icon = getIcon(c.icon);
              return (
                <Link key={c.slug} to={`/etudes-de-cas/${c.slug}`} className="block group" data-testid={`case-link-${c.slug}`}>
                  <Card className="h-full hover:shadow-md transition-shadow border-slate-200 group-hover:border-emerald-300">
                    <CardContent className="p-5">
                      <div className="flex gap-3 mb-3">
                        <div className="flex-shrink-0 p-2 bg-emerald-50 rounded-lg text-emerald-600">
                          <Icon className="h-5 w-5" />
                        </div>
                        <Badge className="bg-slate-100 text-slate-600 text-xs ml-auto hover:bg-slate-100">
                          {c.category}
                        </Badge>
                      </div>
                      <h3 className="font-semibold text-slate-900 group-hover:text-emerald-700 transition-colors mb-2">
                        {c.title}
                      </h3>
                      <p className="text-sm text-slate-500 line-clamp-2">
                        {c.metaDescription}
                      </p>
                      {c.caseDetails ? (
                        <div className="mt-3 pt-3 border-t border-slate-100 flex items-center gap-3 text-xs text-slate-500">
                          <span>Coût : <strong className="text-emerald-700">{c.caseDetails.cost}</strong></span>
                          <span>•</span>
                          <span>{c.caseDetails.duration}</span>
                        </div>
                      ) : null}
                    </CardContent>
                  </Card>
                </Link>
              );
            })}
          </div>
        </div>
      </section>
    </div>
  );
}
